import React from 'react'
import { Platform, ImageBackground, ImageStyle, View, ViewStyle } from 'react-native'
import { color } from '../../theme'

interface BannerProps {
  children?: React.ReactElement
  backgroundImage?: string | undefined
  style?: ViewStyle
  overlayStyle?: ViewStyle
}

export const Banner = (props: BannerProps) => {
  const { backgroundImage, children, overlayStyle, style } = props

  return (
    <View style={{ ...ROOT, ...style }}>
      <View style={CONTAINER}>
        <ImageBackground
          source={{ uri: backgroundImage }}
          resizeMode="cover"
          blurRadius={Platform.OS === 'web' ? 20 : 50}
          imageStyle={IMG}
          style={IMG_BG}
        >
          {children}
          <View style={{ ...OVERLAY, ...overlayStyle }} />
        </ImageBackground>
      </View>
    </View>
  )
}

const ROOT: ViewStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' }
const CONTAINER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  alignSelf: 'center',
  width: '100%',
  height: 93,
}
const IMG: ImageStyle = {
  borderRadius: 20,
  backgroundColor: color.white,
}
const IMG_BG: ViewStyle = {
  alignSelf: 'center',
  borderRadius: 20,
  height: 93,
  width: '100%',
  flex: 1,
}
const OVERLAY: ViewStyle = {
  position: 'absolute',
  backgroundColor: '#fff',
  opacity: 0.9,
  width: '100%',
  borderRadius: 20,
  height: 93,
}
